
export default {
  namespaced: true,
  // State
  state: {
    loading: false,
    errorIsVisible: false,
    errorMessage: '',
    snackbarCentered: false,
    alertIsVisible: false,
    alertMessage: '',
    fullWidth: false,
  },
  // Actions
  actions: {
    // to enable or disable loading screen
    loadingTrigger(context, isVisible) {
      context.commit('LOADING_TRIGGER', isVisible);
    },
    displayAlert(context, params) {
      context.commit('DISPLAY_ALERT', params);
      setTimeout(() => {
        context.commit('RESET_ALERT');
        setTimeout(() => {
          context.commit('RESET_ALERT');
        }, 500);
      }, (params.time * 1000));
    },
    // to display and error text is the error message and time the time to display in sec
    displayError(context, params) {
      // open snack bar
      context.commit('DISPLAY_ERROR_OPEN', params);
      // after param time close snack bar
      setTimeout(() => {
        context.commit('DISPLAY_ERROR_CLOSE');
        setTimeout(() => {
          context.commit('RESET_SNACKBAR');
        }, 500);
      }, (params.time * 1000));
    },
  },
  // Getters
  getters: {
    loading: state => state.loading,
    errorIsVisible: state => state.errorIsVisible,
    errorMessage: state => state.errorMessage,
    snackbarCentered: state => state.snackbarCentered,
    alertIsVisible: state => state.alertIsVisible,
    alertMessage: state => state.alertMessage,
    fullWidth: state => state.fullWidth,
  },
  // Mutations
  mutations: {
    // change loading state
    LOADING_TRIGGER(state, isVisible) {
      state.loading = isVisible;
    },
    RESET_ALERT(state) {
      state.alertIsVisible = false;
    },
    DISPLAY_ALERT(state, params) {
      state.alertMessage = params.text;
      state.alertIsVisible = true;
    },
    // open snackbar
    DISPLAY_ERROR_OPEN(state, params) {
      console.log(params);
      // check if snack bar must be centered
      if (params.centered !== undefined) {
        state.snackbarCentered = true;
      } else {
        state.snackbarCentered = false;
      }
      if (params.fullWidth !== undefined) {
        state.fullWidth = params.fullWidth;
      }
      // check if a snack bar is already opened
      state.errorMessage = params.text;
      state.errorIsVisible = true;
    },
    // close snackbar
    DISPLAY_ERROR_CLOSE(state) {
      state.errorIsVisible = false;
    },
    // reset snackbar posiiton to left
    RESET_SNACKBAR(state) {
      state.snackbarCentered = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/application/index.js